<template>
  <div class="app-wrapper" :class="classObj">
    <div class="fixed-header" :style="{width: !showSidebar ? '100%' : sidebar.opened ? 'calc(100% - 220px)' : 'calc(100% - 36px)'}">
      <navbar :showSidebar="showSidebar"></navbar>
    </div>
    <sidebar class="sidebar-container" :showSidebar="showSidebar"></sidebar>
    <div class="main-container" :class="{'isHome': $route.path === '/home'}">
      <app-main></app-main>
    </div>
  </div>
</template>

<script>
import {Navbar, Sidebar, AppMain} from './components'
import ResizeMixin from './mixin/ResizeHandler'
import {balancePrompt} from "@/views/fund/accountCenter/bingCardPrompt";

export default {
  name: 'layout',
  components: {
    Navbar,
    Sidebar,
    AppMain
  },
  mixins: [ResizeMixin],
  watch: {
    $route(to) {
      this.showSidebar = !(to.meta.showSidebar === false)
    }
  },
  data() {
    return {
      showSidebar: true,
    }
  },
  created() {
    this.showSidebar = !(this.$route.meta.showSidebar === false)
  },
  computed: {
    sidebar() {
      return this.$store.state.app.sidebar
    },
    device() {
      return this.$store.state.app.device
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile',
        noShowSidebar: !this.showSidebar
      }
    },
  },
  mounted() {
    balancePrompt('init')
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "src/styles/mixin.scss";

.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;
  min-width: 1100px;
}

.isHome {
  padding: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/Layout.vue